import React, { useRef, useState } from 'react';
import { ChevronDown as ChevronDownIcon } from 'react-feather';
import { Button, Dropdown } from 'ui-kit';
import './NewProduct.scss';
import { NewProductMode } from 'components/NewProductStepper/NewProductStepper';
import NewProductModal from './NewProductModal';
import MenuItems from 'components/TopNav/MenuItems';

const getItems = (handleNewProductMode, setVisible) => [
  {
    key: 'add',
    label: 'Add product',
    onClick: () => {
      handleNewProductMode('default');
      setVisible(false);
    },
  },
  {
    key: 'quick-add',
    label: 'Quick-add',
    onClick: () => {
      handleNewProductMode('quick');
      setVisible(false);
    },
  },
];

const NewProduct = ({ storeId }: { storeId: number }) => {
  const [newProductMode, setNewProductMode] = useState<NewProductMode | null>();
  const [visible, setVisible] = useState(false);
  const containerRef = useRef();

  const handleNewProductMode = (mode: NewProductMode) => {
    setNewProductMode(mode);
  };

  const handleCleanNewProductMode = () => {
    setNewProductMode(null);
  };

  return (
    <>
      <div ref={containerRef} className="new-product-container">
        <Dropdown
          visible={visible}
          onVisibleChange={(visible) => setVisible(visible)}
          placement="bottomRight"
          trigger={['click']}
          overlay={<MenuItems items={getItems(handleNewProductMode, setVisible)} />}
          getPopupContainer={() => containerRef.current}
        >
          <Button
            className="add-product"
            variant="outlined"
            endIcon={<ChevronDownIcon />}
            data-walkthrough="quick-add"
          >
            Add
          </Button>
        </Dropdown>
        <Button
          className="add-product"
          variant="outlined"
          onClick={() => handleNewProductMode('default')}
        >
          Add product
        </Button>
        <Button
          className="quick-add-product"
          onClick={() => handleNewProductMode('quick')}
          color="primary"
          variant="text"
          data-walkthrough="quick-add"
        >
          Quick-add
        </Button>
      </div>
      <NewProductModal
        storeId={storeId}
        isOpen={Boolean(newProductMode)}
        onCancel={handleCleanNewProductMode}
        mode={newProductMode}
      />
    </>
  );
};

export default NewProduct;
